import features from "features";
import { getItem, setItem, removeItem, removeItemAnon, setItemAnon, getItemAnon } from "utils/localstorage";
import _ from "lodash";

const featuresMap = _.keyBy(features, "key");

const alwaysEnabledFeatures = (process.env.REACT_APP_FEATURES || "").split(";");
export default (state = {active: {}, list: [], servicesList: []}, {payload, type}) => {
    switch (type){
        case "FEATURES:INITIALIZE": {
            const { services, supportServices, selectedAccount } = payload;
            const is3rdPartyServicesEnabled = _.get(selectedAccount, "is3rdPartyServicesEnabled", false)
            const isPrivatePreviewEnabled = _.get(selectedAccount, "isPrivatePreviewEnabled", false)

            const active = {};

            const servicesList = _.chain(services).filter(service => service.service).filter(service => {
                if(process.env.REACT_APP_IS_DARK === "true") {
                    return service.key !== 'license-service'
                } else {
                    return true;
                }
            }).map(service => {
                if(service.service.subServices) {
                    return service.service.subServices.map(subService => ({
                        name: `${service.name} - ${subService.label}`,
                        key: `${service.key}.${subService.key}`,
                        parentKey: service.key,
                        service: subService
                    })).concat(service);
                } else {
                    return service;
                }
            }).flatten().map(service => {
                const feature = {title: `Enable service: ${service.name}`, key: service.key}
                if(process.env.REACT_APP_IS_SAAS !== "true") {
                    const localKey = _.get(service, "service.localKey");
                    const supportServiceKey = _.get(service, "service.supportServiceKey")
                    const isInPreview = supportServiceKey && _.get(supportServices, ["servicesInformation", supportServiceKey, "isInPreview"], false);
                    const isThirdParty = _.get(service, "service.isThirdParty", false);

                    if(!localKey && !supportServiceKey) {
                        active[feature.key] = true;
                        if(service.parentKey) {
                            active[service.parentKey] = true;
                        }
                        return {...feature, active: true, allowToggle: false}
                    }

                    const isSupported = _.get(supportServices, localKey, false) || _.get(supportServices, ["servicesInformation", supportServiceKey, "enabled"], false);
                    const isFlagEnabled = getItem({itemKey: `feature.${service.key}`});
                    const isPermittedByAccount = (!isThirdParty || is3rdPartyServicesEnabled) && (!isInPreview || isPrivatePreviewEnabled);
                    const status = (isSupported || isFlagEnabled) && isPermittedByAccount;

                    if(status) {
                        active[feature.key] = true;
                        if(service.parentKey) {
                            active[service.parentKey] = true;
                        }
                    }

                    return {...feature, active: status, alwaysOn: isSupported, isPermittedByAccount, allowToggle: true};
                } else {
                    const needsFlag = _.get(service, "service.needsFlag", false);
                    const isThirdParty = _.get(service, "service.isThirdParty", false);
                    const isInPreview = _.get(service, "service.isInPreview", false);
                    const key = _.get(service, "key");
                    const isPermittedByAccount = (!isThirdParty || is3rdPartyServicesEnabled) && (!isInPreview || isPrivatePreviewEnabled);

                    if(!needsFlag && isPermittedByAccount) {
                        active[feature.key] = true;
                        if(service.parentKey) {
                            active[service.parentKey] = true;
                        }
                        return {...feature, active: true, allowToggle: false}
                    }
                    const status = (alwaysEnabledFeatures.includes(key) || getItem({itemKey: `feature.${key}`})) && isPermittedByAccount;

                    if(status) {
                        active[feature.key] = true
                        if(service.parentKey) {
                            active[service.parentKey] = true;
                        }
                    }

                    return {...feature, active: status, alwaysOn: alwaysEnabledFeatures.includes(feature.key), isPermittedByAccount, allowToggle: true}
                }
            }).value();

            const list = features.map(feature => {
                const { key } = feature;
                let status = alwaysEnabledFeatures.includes(key);

                if(!status) {
                    if(featuresMap[key].anon) {
                        status = getItemAnon({itemKey: `feature.${key}`});
                    } else {
                        status = getItem({itemKey: `feature.${key}`});
                    }
                }

                if(status) {
                    active[key] = true;
                }

                return {...feature, active: status, alwaysOn: alwaysEnabledFeatures.includes(key)}
            });

            return {active, list, servicesList};
        }
        case "FEATURES:TOGGLE-FEATURE": {
            const {feature} = payload;
            const isActive = state.active[feature];
            const itemKey = `feature.${feature}`;

            if(isActive){
                if(featuresMap[feature]?.anon) {
                    removeItemAnon({itemKey});
                } else {
                    removeItem({itemKey});
                }
            } else {
                if(featuresMap[feature]?.anon) {
                    setItemAnon({itemKey}, true);
                } else {
                    setItem({itemKey}, true)
                }
            }

            window.location.reload();
            return state;
        }
        default :{
            return state;
        }
    }
};
